import { createUseStyles } from 'react-jss';
const useActionButtonStyles = createUseStyles((theme) => ({
    common: {
        height: '36px',
        cursor: 'pointer',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 12px',
        borderRadius: '8px',
        gap: '0.2rem',
        border: 'none',
        transition: 'all 0.150s ease-in-out',
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'auto'),
        '&:hover': {
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)'
        },
        '&:disabled': {
            cursor: 'not-allowed',
            color: theme.colors.grey[0],
            backgroundColor: theme.colors.grey[3],
            boxShadow: 'none'
        }
    },
    default: {
        backgroundColor: 'rgba(51, 92, 255, 1)',
        '&:hover:not([disabled])': {
            backgroundColor: '#3b82f6' // theme.colors.primary.light
        },
        '&:active': {
            boxShadow: ({ disabled }) => disabled
                ? ''
                : 'inset 0px 2px 6px rgba(0, 0, 0, 0.25)!important'
        },
    },
    success: {
        backgroundColor: 'rgb(85, 181, 118)',
        '&:hover:not([disabled])': {
            backgroundColor: '#66c486' // theme.colors.success.light
        },
        '&:active': {
            boxShadow: ({ disabled }) => disabled
                ? ''
                : 'inset 0px 2px 6px rgba(0, 0, 0, 0.25)!important'
        },
    },
    error: {
        backgroundColor: 'rgb(232, 97, 97)',
        '&:hover:not([disabled])': {
            backgroundColor: '#ff8080' // theme.colors.error.light
        },
        '&:active': {
            boxShadow: ({ disabled }) => disabled
                ? ''
                : 'inset 0px 2px 6px rgba(0, 0, 0, 0.25)!important'
        },
    },
    outlined: {
        backgroundColor: '#fff',
        color: 'rgba(82, 88, 102, 1)',
        border: '1px solid rgba(225, 228, 234, 1)',
        '&:hover:not([disabled])': {
            backgroundColor: theme.colors.grey[5]
        },
        '&:disabled': {
            border: 'None'
        }
    }
}));
export default useActionButtonStyles;
